"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEARCH = void 0;
exports.SEARCH = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: () => {
        throw new Error('Function not implemented');
    },
};
//# sourceMappingURL=search.js.map